module.exports = __webpack_public_path__ + "assets/37afd1fecbffb80a9eded06f4bb964b8.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-700-normal.woff2
// module id = 2621
// module chunks = 121